import { Fragment, useState } from 'react';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import Logo from '../Loading/Logo';

export default function InAppBrowserWarning() {
  const [open, setOpen] = useState(true);

  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-1000" onClose={() => {}}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="bg-mt-surface relative transform overflow-hidden rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div>
                  <div className="mx-auto flex h-16 w-16 items-center justify-center">
                    <Logo baseSize={2} />
                  </div>
                  <div className="mt-3 sm:mt-5">
                    <DialogTitle
                      as="h3"
                      className="text-mt-ink text-center text-base leading-6 font-semibold"
                    >
                      A quick heads up
                    </DialogTitle>
                    <div className="mt-2">
                      <p className="text-mt-ink-muted text-sm">
                        It looks like you have opened this trail inside an in
                        app browser.
                      </p>
                      <p className="text-mt-ink-muted text-sm">
                        These built in browsers can sometimes be unreliable and
                        may not remember your progress.
                      </p>
                      <p className="text-mt-ink-muted text-sm">
                        For the best experience, please open this page in your
                        normal browser instead, such as Safari or Chrome.
                      </p>
                      <p className="text-mt-ink-muted text-sm">
                        Look for an option like “Open in browser” or “Open
                        externally” in the menu.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    className="mt-btn bg-mt-primary text-mt-on-primary hover:bg-mt-primary-hover focus-visible:outline-mt-primary inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    Continue
                  </button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
